import { makeStyles, alpha } from "@material-ui/core/styles";
const useQuoteStyles = makeStyles(theme => ({
    modal: {
        "& .MuiDialog-paperWidthMd": {
            width: "25%",
        },
    },
    currencyName: {
        // color: theme.palette.secondary.main, 
        fontWeight: "bold"
    },
    wrapper: {
        width: "85%",
        margin: "1% 3%",
    },
    option: {
        backgroundColor: "red",
    },
    paper: {
        borderRadius: "5px",
        backgroundColor: "#fff",
        padding: theme.spacing(3),
        boxShadow: "0px 1px 4px #0000001A",
        "& input[name='part_number']": { textTransform: "uppercase" },
        "& input[name='item_description']": { textTransform: "uppercase" },
    },
    warning: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "16px",
        marginBottom: "20px",
    },
    input: {
        "&::placeholder": {
            textTransform: "inherit",
        },
    },
    "&::-webkit-input-placeholder": { color: "blue" },
    inputEstimate: {
        "&::placeholder": {
            fontSize: "10px",
        },
    },
    button: {
        padding: "5px !important",
    },
    disableField: {
        pointerEvents: "none",
        backgroundColor: "#F5F5F5",
    },
    disableFieldDesc: {
        pointerEvents: "none",
        backgroundColor: "#F5F5F5",
        textTransform: "uppercase"
    },
    svg: {
        filter: "invert(1)",
        height: 18,
        marginBottom: 2,
    },
    title: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    actionButtons: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },

}));

export default useQuoteStyles;